<template>
<div class="edit-area" v-loading.fullscreen.lock="fullscreenLoading">
  <div class="doc-paper pages page-static" v-if="step == '0' && !cancel_flag">
    <div class="page-static-inner">
      <h2>이력서가 전송되었습니다.</h2>
    </div>
    <p style="font-size: 120%;">비밀번호:</p>
    <div style="display: inline-block;min-width: 100%;">
      <el-input class="input-md"
                placeholder=""
                title="입력 해주세요"
                ref="secure_key"
                v-model="secure_key"
                type="text"></el-input>
    </div>
    <div class="text-center">
      <br/>
      <el-button id="send-introduction" type="success" style="background-color:#e3165c;border-color:#e3165c;color:#FFF"
        @click="$eventHub.$emit('send-secure');">수정</el-button>
    </div>
  </div>
  <div class="preview-dialog" ref="previewDialog" v-if="step == '1' && !cancel_flag">
    <div class="page-static-inner">
      <h2>{{from_name}}님으로부터 이력서가 수신되었습니다.</h2>
    </div>
    <div data-v-114926fe="" class="cards">
        <div data-v-114926fe="" role="tablist" aria-multiselectable="true" class="el-collapse" style="border-top: none; padding-bottom: 30px;">
            <div data-v-114926fe="" class="el-collapse-item is-active">
                <div role="tab" aria-controls="el-collapse-content-7102" aria-describedby="el-collapse-content-7102"
                    aria-expanded="true">
                    <div role="tabpanel" aria-labelledby="el-collapse-head-7102" id="el-collapse-content-7102"
                        class="el-collapse-item__wrap" data-old-padding-top="" data-old-padding-bottom=""
                        data-old-overflow="" style="border-bottom: 0;">
                        <div class="el-collapse-item__content">
                            <div data-v-114926fe="" class="el-collapse-item__content">
                                <p data-v-114926fe="">会社名：<span>{{quickmail_companyname}}</span></p>
                                <p data-v-114926fe="" class="qmail_manager" style="margin-top: 0;">担当者：<span>{{quickmail_staffname}}</span>様
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="backup-preview-dialog">
        <el-tabs v-model="activePreviewTab"
                  class="backup-tabs"
                  ref="elTabs"
                  :stretch="true"
                  @tab-click="setInnerHtml();previewLoading=false"
                  :style="elStyle"
                  >
          <el-tab-pane label="이력서"
                        name="format_rirekisho"
                        ref="rirekisho_pane"
                        :lazy="true"
                  :style="scaleStyle">
          </el-tab-pane>
          <el-tab-pane label="경력기술서"
                        v-if="keirekisho_flag=='1'"
                        name="format_shokumukeirekisho"
                        ref="shokumukeirekisho_pane"
                        :lazy="true"
                  :style="scaleStyle">
          </el-tab-pane>
        </el-tabs>
    </div>

  </div>
  <div class="preview-action"  v-if="step == '1' && !cancel_flag">
    <div class="container-base">
      <ul>
        <li>
          <el-button id="pdf-download-preview"
            class="button-block"
            type="primary"
            v-ripple
            @click="$eventHub.$emit('download-rirekisho', '1');"><i class="el-icon-download"></i> 이력서 PDF다운로드</el-button>
        </li>
        <li >
          <el-button id="pdf-download-preview"
            v-if="keirekisho_flag=='1'"
            class="button-block"
            style="background-color:#fce8ef;border-color:#f4a2be;color:#e3165c"
            type="primary"
            v-ripple
            @click="$eventHub.$emit('download-rirekisho', '2');"><i class="el-icon-download"></i> 이력서 PDF다운로드</el-button>
        </li>
      </ul>
    </div>
  </div>
  <div class="preview-dialog" ref="previewDialog" v-if="cancel_flag">
    <div class="page-static-inner">
      <h2>이 이력서는 발송이 취소되었습니다.</h2>
    </div>
  </div>
</div>
</template>
<style lang="scss" src="@/assets/scss/formats.scss"></style>


<script>
import {
  TabPane,
  Tabs
} from 'element-ui'
import RirekishoPreview from '@/components/formats/RirekishoPreview'
import ShokurekishoPreview from '@/components/formats/ShokurekishoPreview'
import firebase from 'firebase/app'
const RECENT_EDIT_SAVE_KEY = 'recentEdit'
const DOC_PAPER_HEIGHT_PX = 794
export default {
  props: {
    confirmCode: {
      type: String
    }
  },
  components: {
    'rirekisho-preview': RirekishoPreview,
    'shokurekisho-preview': ShokurekishoPreview,
    'el-tabs': Tabs,
    'el-tab-pane': TabPane
  },
  data: function () {
    return {
      fullscreenLoading: false,
      recentEdit: {
        FormatId: ''
      },
      token: null,
      saved: false,
      recomm_code:'',
      step: '0',
      from_name:'',
      secure_key: '',
      saveLabel: '',
      backupDataToConfirm: null,
      previewScale: 1,
      backupDataViewerCssRirekisho: {},
      backupDataViewerCssShokurekisho: {},
      deleteBackupPopoverVisible: false,
      previewLoading: false,
      mailPDFSending: false,
      activeTabName: 'user',
      rirekisho_html: '',
      keirekisho_html: '',
      keirekisho_flag: '0',
      quickmail_companyname: '',
      quickmail_staffname: '',
      rirekisho_height: 110,
      keirekisho_height: 110,
      cancel_flag: false,
      activePreviewTab: 'format_rirekisho'
    }
  },
  computed: {
    getMode: function () {
      return process.env.VUE_APP_MODE
    },
    getClientId: function () {
      return this.clientId
    },
    scaleStyle: function () {
      return {
        'transform': 'scale(' + this.previewScale + ')',
        'transform-origin': 'top left',
      }
    },
    elStyle: function () {
      return {
        'height' : this.rirekisho_height
      }
    },
  },
  methods: {
    setPreviewScale: function () {
      this.$nextTick(function () {
        if (this.$refs.rirekisho_pane.$el.clientWidth === 0) {
        } else {
          const clientWidth = this.$refs.rirekisho_pane.$el.clientWidth
          this.previewScale = clientWidth / Math.max(clientWidth, DOC_PAPER_HEIGHT_PX)
        console.error(this.previewScale)
        }
        this.$nextTick(function () {
          this.setPreviewHeight()
        })
      })
    },
    setPreviewHeight: function () {
      const height = this.$refs.rirekisho_pane.$el.getBoundingClientRect().height
      // const height = 10
      if (!height) {
        return
      }
      if (this.activePreviewTab === 'format_rirekisho' && height > 0) {
        this.backupDataViewerCssRirekisho = {
          height: height + 30 + 'px'
        }
        this.rirekisho_height = height + 30
      } else if (this.activePreviewTab === 'format_shokumukeirekisho' && height > 0) {
        this.backupDataViewerCssShokurekisho = {
          height: height + 30 + 'px'
        }
        this.keirekisho_height = height + 30
      }
    },
    setInnerHtml: function () {
      this.$nextTick(function () {
        this.$refs.rirekisho_pane.$el.innerHTML = this.rirekisho_html
        this.$refs.shokumukeirekisho_pane.$el.innerHTML = this.keirekisho_html
      })
    },
    dataChanged: function () {
      this.saved = false
    },
    downloadPDFWithLink: function (download_flag) {
      const previewOpened = this.previewDialogVisible
      if (!previewOpened) {
        this.previewDialogVisible = true
      }
      const app = this
      this.$nextTick(function () {
        const formData = new FormData()
        formData.append('authentication_key', this.secure_key)
        formData.append('confirm_code', this.confirmCode)
        formData.append('pdf_flag', download_flag)
        this.$axios({
          url: this.$varuna.endPoints.quickmailPdf,
          method: 'post',
          data: formData,
          responseType: 'blob',
          timeout: 40000
        }).then((response) => {
          const pdfBlob = new Blob([response.data], {
            type: 'application/pdf'
          })
          {
            const url = window.URL.createObjectURL(pdfBlob)
            // saveDownloadLog(pdfBlob, filename)
            let link = document.createElement('a')
            link.href = url
            if (download_flag == '1') {
              link.setAttribute('download', app.from_name + '_이력서.pdf')
            } else {
              link.setAttribute('download', app.from_name + '_업무경럭서.pdf')
            }

            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        }).catch(function (error) {
          app.$message({
            message: '다운로드를 실패 하였습니다. 잠시후 다시 시도 해주세요.',
            type: 'error'
          })
        })
      })
      if (!previewOpened) {
        this.previewDialogVisible = false
      }
    },
    downloadPDFWithForm: function (download_flag) {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '오프라인입니다. 인터넷에 접속 해주세요.',
          type: 'warning'
        })
        return
      }
      this.previewDialogVisible = true
      this.$nextTick(function () {
        let pdfURL = this.$varuna.endPoints.quickmailPdfDownload
        let fileName = 'yagish_resume.pdf'
        if (download_flag == '1') {
          fileName = 'yagish_resume.pdf'
        } else {
          fileName = 'yagish_job_resume.pdf'
        }
        const param = {
          'authentication_key' : this.secure_key,
          'confirm_code' : this.confirmCode,
          'pdf_flag' : download_flag,
          'file_name' : fileName
        }
        this.submitForm(pdfURL, param, 'POST')
      })
    },
    submitForm: function (url, data, method) {
      const form = document.createElement('form')
      document.body.appendChild(form)
      form.action = url
      form.method = method
      for (const name in data) {
        let input = document.createElement('input')
        input.type = 'hidden'
        input.name = name
        input.value = data[name]
        form.appendChild(input)
      }
      form.submit()
      document.body.removeChild(form)
    },
    downloadPDF: function (download_flag) {
      const app = this
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '오프라인입니다. 인터넷에 접속 해주세요.',
          type: 'warning'
        })
        return
      }
      if (this.$deviceLib.isIE) {
        this.downloadPDFWithForm(download_flag)
      } else {
        // this.downloadPDFWithForm(download_flag)
        this.downloadPDFWithLink(download_flag)
      }
    },
    sendSecure: function () {
      const app = this
      app.fullscreenLoading = true
      const formData = new FormData()
      formData.append('authentication_key', this.secure_key)
      formData.append('confirm_code', this.confirmCode)

      this.$axios
        .post(this.$varuna.endPoints.getQuickemail, formData, {timeout: 60000})
        .then(function (response) {
          if (response.data.cancel_flag == '1') {
            app.cancel_flag = true
          } else {
            app.rirekisho_html = response.data.rirekisho_html
            app.keirekisho_html = response.data.keirekisho_html
            app.keirekisho_flag = response.data.keirekisho_flag
            app.from_name = response.data.from_name
            app.quickmail_companyname = response.data.quickmail_companyname
            app.quickmail_staffname = response.data.quickmail_staffname

            app.step = '1'
            app.$cookies.config(0,'')
            app.$cookies.set('QUICKEMAIL_SECURE_KEY', app.secure_key, null, null, 'yagish.jp')
            app.$cookies.set('QUICKEMAIL_SECURE_KEY', app.secure_key, null, null, null)
            app.setInnerHtml()

            app.setPreviewScale()
            // app.$refs.rirekisho_pane.$el.innerHTML = app.rirekisho_html
            // app.$refs.shokumukeirekisho_pane.$el.innerHTML = app.keirekisho_html
            app.$message({
              duration: 2000,
              showClose: true,
              dangerouslyUseHTMLString: true,
              message: `수정성공`,
              type: 'info'
            })
          }

        })
        .catch(function (error) {
          app.$message({
            duration: 5000,
            showClose: true,
            message: error.response.data+'.입력내용을 확인하시고 다시 입력 해주세요.',
            type: 'error'
          })
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  created: function () {
    var _secure_key  = this.$cookies.get('QUICKEMAIL_SECURE_KEY')
    if (_secure_key) {
      this.secure_key = _secure_key
      this.sendSecure()
    }
    // const app = this
    // const formData = new FormData()
    // formData.append('token', 'accessToken')
    // this.$axios
    //   .post(this.$varuna.endPoints.getQuickemail, formData, {timeout: 60000})
    //   .then(function (response) {
    //     app.rirekisho_html = response.data.rirekisho_html
    //     app.keirekisho_html = response.data.keirekisho_html

    //     app.$refs.rirekisho_pane.$el.innerHTML = app.rirekisho_html
    //     app.$refs.shokumukeirekisho_pane.$el.innerHTML = app.keirekisho_html
    //   })
    //   .catch(function (error) {
    //   }).finally(function () {
    //     app.fullscreenLoading = false
    //   })
  },
  beforeMount: function () {
    this.$eventHub.$on('download-rirekisho', this.downloadPDF)
    this.$eventHub.$on('send-secure', this.sendSecure)
  },
  destroyed: function () {
    this.$eventHub.$off('download-rirekisho', this.downloadPDF)
    this.$eventHub.$off('send-secure', this.sendSecure)
  }
}
</script>